import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";

import { cn } from "../../../components/common/u1/cn";
import { PageContainer } from "../../../components/common/u1/PageContainer";
import { MembershipHero } from "../../../components/public/Membership/u1/MembershipHero";
import { BenefitGrid } from "../../../components/public/Membership/u1/BenefitGrid";
import { TrustStrip } from "../../../components/public/Membership/u1/TrustStrip";
import { MembershipPlanCard } from "../../../components/public/Membership/u1/MembershipPlanCard";
import { useMembershipCheckout } from "../../../components/public/Membership/u1/useMembershipCheckout";
import { ReactComponent as TrevexLogo } from "../../../assets/images/logo.svg";
import "../../../components/common/u1/tokens.css";

/* u1 Become a Member — /u1/membership/:companyId. */
const stripePromise = loadStripe(process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY);

export default function Membership() {
  const { companyId } = useParams();
  const navigate = useNavigate();

  /* Transcribed: no lead and no token here — this route runs the direct
     company_id checkout, and Skip just returns to the dashboard rather than
     resuming the gated verify flow. */
  const checkout = useMembershipCheckout({
    companyId,
    onSkip: () => navigate("/dashboard"),
  });

  return (
    <div className="u1-root min-h-screen w-full bg-[var(--bg)]">
      {/* A deliberately minimal bar: this is the last step of a purchase, and
          the live screen drops the full navigation for the same reason. */}
      <header className="sticky top-0 z-30 border-b border-[var(--line)] bg-white">
        <PageContainer>
          <div className="flex h-[68px] items-center gap-3.5">
            <TrevexLogo className="h-8 w-auto" />
            <span aria-hidden="true" className="h-[22px] w-px bg-[var(--line)]" />
            <span className="text-[13px] font-medium text-[var(--ink-2)] font-sans">
              Become a member
            </span>
          </div>
        </PageContainer>
      </header>

      <PageContainer className="py-8 pb-20">
        <MembershipHero companyName={checkout.companyName} />

        <div
          className={cn(
            "mt-7 grid grid-cols-1 items-start gap-7",
            "md:grid-cols-[minmax(0,1fr)_400px]"
          )}
        >
          <div>
            <BenefitGrid />
            <TrustStrip className="mt-5" />
          </div>

          <MembershipPlanCard checkout={checkout} stripePromise={stripePromise} />
        </div>
      </PageContainer>
    </div>
  );
}
